import { Toaster } from "@/components/ui/sonner";
import { Outlet } from "react-router";
import { Suspense } from "react";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import SidebarTemplate from "../templates/sidebar-content";
import Header from "../templates/header";
const MainLayout = () => {
  return (
    <div className="persian-font">
      <SidebarProvider>
        <SidebarTemplate />
        <SidebarInset>
          <div className="h-dvh flex flex-col">
            <Toaster position="top-center" />
            <Header />
            <main className="grow flex">
              <Suspense fallback={null}>
                <Outlet />
              </Suspense>
            </main>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </div>
  );
};

export default MainLayout;
